class LGPD
{
    static gtmID = '';
    static cookieName = 'lgpd-consent';
    static defaultConsent = {essentials: true, track: true};

    static getCookie(name)
    {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) {
                try {
                    return JSON.parse(c.substring(nameEQ.length, c.length));
                } catch (e) {
                    return null;
                }
            }
        }
        return null;
    }

    static setCookie(name, value, days)
    {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + JSON.stringify(value) + expires + "; path=/";
    }

    static removeCookies()
    {
        let updatedConsent = LGPD.loadConsent();

        document.cookie.split(';').forEach((cookie) =>
        {
            let name = cookie.split('=')[0].trim();
        
            if (name !== this.cookieName)
            {
                document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

                if (name.includes('analytics')) updatedConsent.essentials = false;
                if (name.includes('track')) updatedConsent.track = false;
            }
        });

        LGPD.saveConsent(updatedConsent);
    }

    static removeAllCookies()
    {
        let newConsent = { essentials: false, track: false };

        LGPD.setCookie(LGPD.cookieName, newConsent, 90);
    }
    
    static loadGTM(consent = null)
    {
        consent = consent || LGPD.loadConsent();
    
        if (consent.track) {
            if (!document.getElementById('gtm-script')) {
                let script = document.createElement('script');
                script.id = 'gtm-script';
                script.async = true;
                script.src = 'https://www.googletagmanager.com/gtm.js?id=' + LGPD.gtmID;
                document.head.appendChild(script);
            }

            /*
            <!-- Google tag (gtag.js) -->
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-CWNZ99H1WJ"></script>
            <script>
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-CWNZ99H1WJ');
            </script>
            */
        }
        else
        {
            let existingScript = document.getElementById('gtm-script');
        
            if (existingScript)
                existingScript.remove();
        }
    }
    

    static showConsentBox()
    {
        document.getElementById('lgpd-box').style.display = 'block';
        document.getElementById('CCLGPD').style.display = 'block';
    }

    static hideConsentBox() {
        document.getElementById('lgpd-box').style.display = 'none';
    }

    static showManageBox() {
        document.getElementById('lgpd-manage-box').style.display = 'block';
        document.getElementById('CCLGPD').style.display = 'block';
    }

    static hideManageBox() {
        document.getElementById('lgpd-manage-box').style.display = 'none';
    }
    
    static applyConsent(consent)
    {
        if (consent.track)
            LGPD.loadGTM();
        else
            LGPD.removeAllCookies();
    }

    static loadConsent()
    {
        return LGPD.getCookie(LGPD.cookieName) || this.defaultConsent;
    }

    static saveConsent(consent)
    {
        LGPD.setCookie(LGPD.cookieName, consent, 90);
        LGPD.applyConsent(consent);
    }
    
    init(gtmID)
    {
        if(gtmID)
        {
            const consent = LGPD.loadConsent();

            LGPD.gtmID = gtmID;

            if (!LGPD.getCookie(LGPD.cookieName))
                LGPD.showConsentBox();
            else
                LGPD.applyConsent(consent);
            
            document.getElementById('lgpd-accept').addEventListener('click', () => 
            {
                LGPD.saveConsent({ essentials: true, track: true });
                LGPD.hideConsentBox();
                document.getElementById('CCLGPD').style.display = 'none';
            });

            document.getElementById('lgpd-manage').addEventListener('click', () => 
            {
                LGPD.showManageBox();
                LGPD.hideConsentBox();
            });

            document.querySelectorAll('.lgpd-manage').forEach((element) => {
                element.addEventListener('click', () => {
                    LGPD.showManageBox();
                    LGPD.hideConsentBox();
                });
            });

            document.getElementById('lgpd-back').addEventListener('click', () => 
            {
                LGPD.hideManageBox();
                LGPD.showConsentBox();
            });

            document.getElementById('lgpd-save').addEventListener('click', () => 
            {
                let newConsent = {
                    essentials: document.getElementById('lgpd-essentials').checked,
                    track: document.getElementById('lgpd-track').checked,
                };

                LGPD.saveConsent(newConsent);
                LGPD.hideManageBox();

                document.getElementById('CCLGPD').style.display = 'none';
            });
        }
    }
}

export default LGPD;
